import React from 'react';
import {
  Row, Col, Typography, Card, Form, Button,
} from 'antd';
import PropTypes from 'prop-types';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import SelectedLands from '../../../serviceComponents/selectedLands/SelectedLands';
import GeoMapSummary from '../../../serviceComponents/geoMapSummary/GeoMapSummary';
import DetailsFields from '../detailsFields/DetailsFields';
import './Details.scss';

const Details = (props) => {
  const {
    removeSelectedField, serviceRequestParameters, nextPage, previousPage,
  } = props;

  const [formInstance] = Form.useForm();

  const handleSubmit = (values) => {
    nextPage({
      ...serviceRequestParameters,
      details: {
        ...values,
      },
    });
  };

  return (
    <div className="VantMapErvasInvasorasDetails">
      <Row
        justify="space-between"
        className="VantMapErvasInvasorasDetails__TitleRow"
      >
        <Col
          className="VantMapErvasInvasorasDetails__TitleCol"
        >
          <Typography.Title
            level={1}
            className="VantMapErvasInvasorasDetails__Title"
          >
            Novo Serviço: Vant
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="VantMapErvasInvasorasDetails__ContentRow"
      >
        <Col
          span={24}
          className="VantMapErvasInvasorasDetails__ContentColumn"
        >
          <Card
            className="VantMapErvasInvasorasDetails__ContentCard"
          >
            <Row
              gutter={[24, 24]}
              className="VantMapErvasInvasorasDetails__FormRow"
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="VantMapeamentoErvasInvasorassDetails__FormColumn"
              >
                <Form
                  className="VantMapeamentoErvasInvasorassDetails__Form"
                  layout="vertical"
                  form={formInstance}
                  onFinish={handleSubmit}
                  onFinishFailed={
                    (errorInfo) => {
                      console.log('VantMapeamentoErvasInvasorassDetails onFinishFailed', errorInfo);
                      console.log('fields', formInstance.getFieldsValue());
                    }
                  }
                >
                  <DetailsFields
                    formInstance={formInstance}
                    initialValuesObject={
                      serviceRequestParameters
                        ?.serviceRequestFieldInputList?.length
                        ? Object.fromEntries(
                          serviceRequestParameters
                            ?.serviceRequestFieldInputList
                            ?.map(
                              (val) => {
                                return [val.idCode, val.value];
                              },
                            ),
                        )
                        : undefined
                    }
                    mode="CREATE"
                  />
                </Form>
              </Col>

              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="VantMapErvasInvasorasDetails__LandAndSummaryColumn"
              >
                <SelectedLands
                  talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                  removeSelectedField={removeSelectedField}
                />
                <GeoMapSummary params={serviceRequestParameters} />
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              justify="end"
              className="VantMapErvasInvasorasDetails__ButtonRow"
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="VantMapErvasInvasorasDetails__ButtonFirstColumn"
              >
                <Button
                  block
                  className="VantMapErvasInvasorasDetails__BackButton"
                  onClick={() => previousPage()}
                >
                  <ArrowLeftIcon className="VantMapErvasInvasorasDetails__ArrowLeftIcon" />
                  Voltar
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="VantMapErvasInvasorasDetails__ButtonSecondColumn"
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="VantMapErvasInvasorasDetails__ContinueButton"
                  onClick={
                    (eventt) => {
                      eventt.preventDefault();
                      formInstance.submit();
                    }
                  }
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Details.propTypes = {
  removeSelectedField: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  serviceRequestParameters: PropTypes.shape({
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.any).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.any),
    serviceRequestFieldInputList: PropTypes.arrayOf(PropTypes.shape({})),
    service: PropTypes.string,

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Details.defaultProps = {};

export default Details;
